;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { NextResponse } from "next/server";

/** Codes aligned with `.cursor/rules/api-routes.md`. */
export type ApiErrorCode =
	| "UNAUTHORIZED"
	| "FORBIDDEN"
	| "NOT_FOUND"
	| "VALIDATION_ERROR"
	| "CONFLICT"
	| "INTERNAL_ERROR";

export interface ApiErrorBody {
	error: {
		code: ApiErrorCode | string;
		message: string;
		details?: unknown;
	};
}

export function apiRouteError(
	code: ApiErrorCode | string,
	message: string,
	status: number,
	details?: unknown,
) {
	const body: ApiErrorBody = {
		error: {
			code,
			message,
			...(details !== undefined ? { details } : {}),
		},
	};

	return NextResponse.json(body, { status });
}

export function apiRouteSuccess<T>(body: T, status = 200) {
	return NextResponse.json(body, { status });
}

export function apiRouteUnauthorized(message = "Invalid or missing token") {
	return apiRouteError("UNAUTHORIZED", message, 401);
}

export function apiRouteValidationError(
	message = "Invalid request data",
	details?: unknown,
) {
	return apiRouteError("VALIDATION_ERROR", message, 400, details);
}

export function apiRouteInternalError(message = "An internal error occurred") {
	return apiRouteError("INTERNAL_ERROR", message, 500);
}

function isRecord(value: unknown): value is Record<string, unknown> {
	return typeof value === "object" && value !== null && !Array.isArray(value);
}

/** Normalize API error JSON for client fetchers (nested or legacy flat shapes). */
export function getApiErrorMessage(
	errorData: unknown,
	fallback: string,
): string {
	if (!isRecord(errorData)) {
		return fallback;
	}

	const nestedError = errorData.error;
	if (isRecord(nestedError)) {
		if (
			typeof nestedError.message === "string" &&
			nestedError.message.length > 0
		) {
			return nestedError.message;
		}
		if (typeof nestedError.code === "string" && nestedError.code.length > 0) {
			return nestedError.code;
		}
	}

	if (
		typeof errorData.errorMessage === "string" &&
		errorData.errorMessage.length > 0
	) {
		return errorData.errorMessage;
	}

	if (typeof errorData.message === "string" && errorData.message.length > 0) {
		return errorData.message;
	}

	if (typeof errorData.error === "string" && errorData.error.length > 0) {
		return errorData.error;
	}

	return fallback;
}
